import React, { Fragment } from "react";
import { Colxx, Separator } from "Components/CustomBootstrap";
import BreadcrumbContainer from "Components/BreadcrumbContainer";
import IntlMessages from "Util/IntlMessages";
import { Row, Card, CardBody } from "reactstrap";
import Fullscreen from "Components/Fullscreen";

function columns() {
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <BreadcrumbContainer
              heading={<IntlMessages id="menu.columns" />}
            />
            <div className="float-right">
              <Fullscreen />
            </div>
            <Separator className="mb-5" />
          </Colxx>
        </Row>

        {/* Columns */}
        <Row>
          <Colxx lg="12" className="mb-5">
            <Card>
              <CardBody>
                This row contains two columns maximum is <code> xl="12" </code>{" "}
                in this row we created two column using{" "}
                <code>xl="9" & xl="3" </code> making total of 12 Math: 9 + 3 =
                12
              </CardBody>
            </Card>
          </Colxx>
          <Colxx xl="9" md="12" className="pl-0 pr-0 mb-5">
            <div className="pr-3 pl-3">
              <Card>
                <div>
                  <CardBody>
                    <h6 className="mb-4">
                      <span className="fa fa-chalkboard mr-1" /> Three Fourth
                      3/4
                    </h6>
                    At vero eos et accusamus et iusto odio dignissimos ducimus
                    qui blanditiis praesentium voluptatum deleniti atque
                    corrupti quos dolores et quas molestias excepturi sint
                    occaecati cupiditate non provident, similique sunt in culpa
                    qui officia deserunt mollitia animi, id est laborum et
                    dolorum fuga. Et harum quidem rerum facilis est
                  </CardBody>
                </div>
              </Card>
            </div>
          </Colxx>
          <Colxx xl="3" md="12">
            <div className="pr-3 pl-3">
              <Card>
                <div>
                  <CardBody>
                    <h6 className="mb-4">
                      <span className="fa fa-chalkboard mr-1" /> One Fourth 1/4
                    </h6>
                    At vero eos et accusamus et iusto odio dignissimos.
                  </CardBody>
                </div>
              </Card>
            </div>
          </Colxx>
        </Row>
        {/* Column Ends Here */}

        {/* Columns */}
        <Row>
          <Colxx lg="12" className="mb-5">
            <Card>
              <CardBody>
                This row contains columns maximum is <code> xl="12" </code> in
                this row we created columns using <code>xl="4" & xl="8" </code>{" "}
                making total of 12 Math: 4 + 8 = 12
              </CardBody>
            </Card>
          </Colxx>
          <Colxx xl="4" md="12" className="pl-0 pr-0 mb-5">
            <div className="pr-3 pl-3">
              <Card>
                <div>
                  <CardBody>
                    <h6 className="mb-4">
                      <span className="fa fa-chalkboard mr-1" /> One Third 1/3
                    </h6>
                    At vero eos et accusamus et iusto odio dignissimos ducimus
                    qui blanditiis praesentium voluptatum deleniti atque
                    corrupti quos dolores et quas molestias.
                  </CardBody>
                </div>
              </Card>
            </div>
          </Colxx>
          <Colxx xl="8" md="12">
            <div className="pr-3 pl-3">
              <Card>
                <div>
                  <CardBody>
                    <h6 className="mb-4">
                      <span className="fa fa-chalkboard mr-1" /> Two Third 2/3
                    </h6>
                    At vero eos et accusamus et iusto odio dignissimos ducimus
                    qui blanditiis praesentium voluptatum deleniti atque
                    corrupti quos dolores et quas molestias excepturi sint
                    occaecati cupiditate non provident, similique sunt in culpa
                    qui officia deserunt mollitia animi, id est laborum et
                    dolorum fuga. Et harum quidem rerum facilis est
                  </CardBody>
                </div>
              </Card>
            </div>
          </Colxx>
        </Row>
        {/* Column Ends Here */}

        {/* Columns */}
        <Row>
          <Colxx lg="12" className="mb-5">
            <Card>
              <CardBody>
                This row contains columns maximum is <code> xl="12" </code> in
                this row we created columns using{" "}
                <code>xl="3" xl="6" & xl="3" </code> making total of 12 Math: 3
                + 6 + 3 = 12
              </CardBody>
            </Card>
          </Colxx>
          <Colxx xl="3" md="12" className="pl-0 pr-0 mb-5">
            <div className="pr-3 pl-3">
              <Card>
                <div>
                  <CardBody>
                    <h6 className="mb-4">
                      <span className="fa fa-chalkboard mr-1" /> One Third 1/3
                    </h6>
                    At vero eos et accusamus et iusto odio..
                  </CardBody>
                </div>
              </Card>
            </div>
          </Colxx>
          <Colxx xl="6" md="12" className="pl-0 pr-0 mb-5">
            <div className="pr-3 pl-3">
              <Card>
                <div>
                  <CardBody>
                    <h6 className="mb-4">
                      <span className="fa fa-chalkboard mr-1" /> Two Third 2/3
                    </h6>
                    At vero eos et accusamus et iusto odio dignissimos ducimus
                    qui blanditiis praesentium voluptatum deleniti...
                  </CardBody>
                </div>
              </Card>
            </div>
          </Colxx>
          <Colxx xl="3" md="12">
            <div className="pr-3 pl-3">
              <Card>
                <div>
                  <CardBody>
                    <h6 className="mb-4">
                      <span className="fa fa-chalkboard mr-1" /> One Third 1/3
                    </h6>
                    At vero eos et accusamus et iusto odio..
                  </CardBody>
                </div>
              </Card>
            </div>
          </Colxx>
        </Row>
        {/* Column Ends Here */}

        {/* Columns */}
        <Row>
          <Colxx lg="12" className="mb-5">
            <Card>
              <CardBody>
                This row contains columns maximum is <code> xl="12" </code> in
                this row we created columns using{" "}
                <code>xl="4" xl="4" & xl="4" </code> making total of 12 Math: 4
                + 4 + 4 = 12
              </CardBody>
            </Card>
          </Colxx>
          <Colxx xl="4" md="12" className="pl-0 pr-0 mb-5">
            <div className="pr-3 pl-3">
              <Card>
                <div>
                  <CardBody>
                    <h6 className="mb-4">
                      <span className="fa fa-chalkboard mr-1" /> One Third 1/3
                    </h6>
                    At vero eos et accusamus et iusto odio dignissimos ducimus
                    qui blanditiis praesentium voluptatum deleniti...
                  </CardBody>
                </div>
              </Card>
            </div>
          </Colxx>
          <Colxx xl="4" md="12" className="pl-0 pr-0 mb-5">
            <div className="pr-3 pl-3">
              <Card>
                <div>
                  <CardBody>
                    <h6 className="mb-4">
                      <span className="fa fa-chalkboard mr-1" /> One Third 1/3
                    </h6>
                    At vero eos et accusamus et iusto odio dignissimos ducimus
                    qui blanditiis praesentium voluptatum deleniti...
                  </CardBody>
                </div>
              </Card>
            </div>
          </Colxx>
          <Colxx xl="4" md="12">
            <div className="pr-3 pl-3">
              <Card>
                <div>
                  <CardBody>
                    <h6 className="mb-4">
                      <span className="fa fa-chalkboard mr-1" /> One Third 1/3
                    </h6>
                    At vero eos et accusamus et iusto odio dignissimos ducimus
                    qui blanditiis praesentium voluptatum deleniti...
                  </CardBody>
                </div>
              </Card>
            </div>
          </Colxx>
        </Row>
        {/* Column Ends Here */}

        {/* Columns */}
        <Row>
          <Colxx lg="12" className="mb-5">
            <Card>
              <CardBody>
                This row contains columns maximum is <code> xl="12" </code> in
                this row we created columns using <code>xl="6" & xl="6" </code>{" "}
                making total of 12 Math: 6 + 6 = 12
              </CardBody>
            </Card>
          </Colxx>
          <Colxx xl="6" md="12" className="pl-0 pr-0 mb-5">
            <div className="pr-3 pl-3">
              <Card>
                <div>
                  <CardBody>
                    <h6 className="mb-4">
                      <span className="fa fa-chalkboard mr-1" /> One Half 1/2
                    </h6>
                    At vero eos et accusamus et iusto odio dignissimos ducimus
                    qui blanditiis praesentium voluptatum deleniti...
                  </CardBody>
                </div>
              </Card>
            </div>
          </Colxx>
          <Colxx xl="6" md="12" className="pl-0 pr-0 mb-5">
            <div className="pr-3 pl-3">
              <Card>
                <div>
                  <CardBody>
                    <h6 className="mb-4">
                      <span className="fa fa-chalkboard mr-1" /> One Half 1/2
                    </h6>
                    At vero eos et accusamus et iusto odio dignissimos ducimus
                    qui blanditiis praesentium voluptatum deleniti...
                  </CardBody>
                </div>
              </Card>
            </div>
          </Colxx>
        </Row>
        {/* Column Ends Here */}

        {/* Columns */}
        <Row>
          <Colxx lg="12" className="mb-5">
            <Card>
              <CardBody>
                This row contains column maximum is <code> xl="12" </code> in
                this row we created this column using{" "}
                <code>xl="6" classNmae="mx-auto" </code> mx-auto was used for
                centering column.
              </CardBody>
            </Card>
          </Colxx>
          <Colxx xl="6" md="12" className="pl-0 pr-0 mb-5 mx-auto">
            <div className="pr-3 pl-3">
              <Card>
                <div>
                  <CardBody>
                    <h6 className="mb-4">
                      <span className="fa fa-chalkboard mr-1" /> One Half 1/2
                    </h6>
                    At vero eos et accusamus et iusto odio dignissimos ducimus
                    qui blanditiis praesentium voluptatum deleniti...
                  </CardBody>
                </div>
              </Card>
            </div>
          </Colxx>
        </Row>
        {/* Column Ends Here */}

        {/* Columns */}
        <Row>
          <Colxx lg="12" className="mb-5">
            <Card>
              <CardBody>
                This row contains left column maximum is <code> xl="12" </code>{" "}
                in this row we created this column using{" "}
                <code>xl="6" classNmae="mr-auto" </code> mr-auto was used for
                placing column on left.
              </CardBody>
            </Card>
          </Colxx>
          <Colxx xl="6" md="12" className="pl-0 pr-0 mb-5 mr-auto">
            <div className="pr-3 pl-3">
              <Card>
                <div>
                  <CardBody>
                    <h6 className="mb-4">
                      <span className="fa fa-chalkboard mr-1" /> One Half 1/2
                    </h6>
                    At vero eos et accusamus et iusto odio dignissimos ducimus
                    qui blanditiis praesentium voluptatum deleniti...
                  </CardBody>
                </div>
              </Card>
            </div>
          </Colxx>
        </Row>
        {/* Column Ends Here */}

        {/* Columns */}
        <Row>
          <Colxx lg="12" className="mb-5">
            <Card>
              <CardBody>
                This row contains right column maximum is <code> xl="12" </code>{" "}
                in this row we created this column using{" "}
                <code>xl="6" classNmae="ml-auto" </code> ml-auto was used for
                placing column on right.
              </CardBody>
            </Card>
          </Colxx>
          <Colxx xl="6" md="12" className="pl-0 pr-0 mb-5 ml-auto">
            <div className="pr-3 pl-3">
              <Card>
                <div>
                  <CardBody>
                    <h6 className="mb-4">
                      <span className="fa fa-chalkboard mr-1" /> One Half 1/2
                    </h6>
                    At vero eos et accusamus et iusto odio dignissimos ducimus
                    qui blanditiis praesentium voluptatum deleniti...
                  </CardBody>
                </div>
              </Card>
            </div>
          </Colxx>
        </Row>
        {/* Column Ends Here */}

        {/* Columns */}
        <Row>
          <Colxx lg="12" className="mb-5">
            <Card>
              <CardBody>
                This row contains right column maximum is <code> xl="12" </code>{" "}
                in this row we created this column using{" "}
                <code>
                  xl="6" classNmae="ml-auto" & xl="6" classNmae="mr-auto"{" "}
                </code>{" "}
                ml-auto was used for placing column on right and mr-auto for
                place column on left.
              </CardBody>
            </Card>
          </Colxx>
          <Colxx xl="4" md="12" className="pl-0 pr-0 mb-5 mr-auto">
            <div className="pr-3 pl-3">
              <Card>
                <div>
                  <CardBody>
                    <h6 className="mb-4">
                      <span className="fa fa-chalkboard mr-1" /> One Half 1/2
                    </h6>
                    At vero eos et accusamus et iusto odio dignissimos ducimus
                    qui blanditiis praesentium voluptatum deleniti...
                  </CardBody>
                </div>
              </Card>
            </div>
          </Colxx>
          <Colxx xl="4" md="12" className="pl-0 pr-0 mb-5 ml-auto">
            <div className="pr-3 pl-3">
              <Card>
                <div>
                  <CardBody>
                    <h6 className="mb-4">
                      <span className="fa fa-chalkboard mr-1" /> One Half 1/2
                    </h6>
                    At vero eos et accusamus et iusto odio dignissimos ducimus
                    qui blanditiis praesentium voluptatum deleniti...
                  </CardBody>
                </div>
              </Card>
            </div>
          </Colxx>
        </Row>
        {/* Column Ends Here */}
      </Fragment>
    );
}

export default columns;
